import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Table from 'react-bootstrap/Table';
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import Swal from "sweetalert2";
import loader from "../../../assets/Images/loader.gif";
import { toast } from "react-toastify";
import autoTable from "jspdf-autotable"; // ✅ Correct way to import autoTable


const PurchaseOrder = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [pgName, setPgName] = useState("");
    const [pgAddress, setPgAddress] = useState("");
    const [pgOwnerName, setPgOwnerName] = useState("");
    const [ownerContact, setOwnerContact] = useState("");
    const [ownerEmail, setOwnerEmail] = useState("");
    const [floorCount, setFloorCount] = useState("");
    const [roomCount, setRoomCount] = useState("");
    const [bedCount, setBedCount] = useState("");
    const [floorList, setFloorList] = useState("");
    const [commonAreaList, setCommonAreaList] = useState("");

    const [oneTimeCharge, setOneTimeCharge] = useState("");
    const [securityDeposit, setSecurityDeposit] = useState("");
    const [IsDownloading, setIsDownloading] = useState(true);

    const [pricingBasePlancount, setPricingBasePlancount] = useState("");
    const [pricingBasePlanrate, setPricingBasePlanrate] = useState("");
    const [pricingBasePlanBillingAmt, setPricingBasePlanBillingAmt] = useState("");
    const [addOns, setAddOns] = useState([]);
    const [totalRecurringPrice, setTotalRecurringPrice] = useState("");
    const [billingAmountFreqBasis, setBillingAmountFreqBasis] = useState("");
    const [billingFreqValue, setBillingFreqValue] = useState("");
    const [effectivePrice, setEffectivePrice] = useState("");
    const [projectedAPCount, setProjectedAPCount] = useState("");
    const [pgTenantType, setPgTenantType] = useState("");
    const [basePlanName, setBasePlanName] = useState("");
    const [planDescription, setPlanDescription] = useState("");
    const [basePlanSpeed, setBasePlanSpeed] = useState("");
    const [basePlanDataVolume, setBasePlanDataVolume] = useState("");
    const [basePlanDeviceCount, setBasePlanDeviceCount] = useState("");
    const [poNumber, setPoNumber] = useState("");
    const [poDate, setPoDate] = useState("");
    const [licenseCount, setLicenseCount] = useState();
    const [getOppData, setOppData] = useState(0);

    // const OppId = "O-04-2025-148941";
    // const OppId = "O-04-2025-98003";

    const currentDate = new Date();
    const formattedCurrentDate = currentDate.toISOString().split('T')[0];
    const toDate = formattedCurrentDate;


    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const OppId = searchParams.get("OppId");
    const navigate = useNavigate();

    const redirectOpportunity = () => {
        navigate(`/BusinessPgOpp?OppId=${OppId}`);
    };



    // Remove all hyphens from the string
    const noDash = OppId.split('-').join(''); // "O04202598003"

    // Replace the first character "O" with "PO"
    const finalId = "PO" + noDash.slice(1);

    // console.log(finalId); // Output: "PO04202598003"




    const downloadPDF = () => {
        setIsLoading(true);
        const sections = document.querySelectorAll('.section-purchase2');
        // if (sections.length === 0) return;
        if (sections.length === 0) {
            setIsLoading(false);
            return;
        }



        const scaleFactor = 2.5; // Always use desktop scaling
        const pdf = new jsPDF("p", "mm", "a4", true); // Always portrait
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();
        const pdfMargin = 10;
        const imgWidth = pageWidth - 2 * pdfMargin;
        const marginX = (pageWidth - imgWidth) / 2;

        let promiseChain = Promise.resolve();

        sections.forEach((section, index) => {
            promiseChain = promiseChain.then(() => {
                // Clone the section
                const clone = section.cloneNode(true);

                // Apply a fixed desktop width style to the clone
                clone.style.width = "1200px";
                clone.style.maxWidth = "none";

                // Hide it off-screen
                clone.style.position = "absolute";
                clone.style.top = "-9999px";
                clone.style.left = "-9999px";
                document.body.appendChild(clone);

                return html2canvas(clone, { scale: scaleFactor }).then((canvas) => {
                    const imgData = canvas.toDataURL("image/png", 0.75);
                    const imgHeight = (canvas.height * imgWidth) / canvas.width;

                    if (index > 0) {
                        pdf.addPage("p");
                    }
                    pdf.addImage(imgData, "PNG", marginX, pdfMargin, imgWidth, imgHeight);

                    // Clean up after rendering
                    document.body.removeChild(clone);
                });
            });
        });

        promiseChain.then(() => {
            // pdf.save("PG_PO_" + OppId + ".pdf");

            // toast.success("PO Document downloaded", {
            //     autoClose: 1500,
            // });
            pdf.save("PG_PO_" + OppId + ".pdf");
            toast.success("PO Document downloaded", {
                autoClose: 1500,
            });
        })
            .catch((error) => {
                console.error("Error generating PDF:", error);
                toast.error("Error downloading PO Document");
            })
            .finally(() => {
                // Hide loader
                setIsLoading(false);
            });

    };






    useEffect(() => {
        const fetchData = async () => {
            try {
                setIsLoading(true);
                const response = await fetch(
                    process.env.REACT_APP_API_URL,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({
                            Action: "getopportunity",
                            Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                            LeadId: "",
                            OppId: OppId,
                            password: sessionStorage.getItem("password"),
                            userName: sessionStorage.getItem("userName"),
                        }),
                    }
                );

                const data = await response.json();
                if (data.Status === "Success" && data.Response?.Data?.length > 0) {
                    setOppData((data.Response.Data).length)
                    setPoNumber(finalId);
                    setPoDate(toDate);
                    const opportunity = data.Response.Data[0];

                    setProjectedAPCount(opportunity.PgInfo?.APcount || "");

                    setPgName(opportunity.PgInfo?.PGName || "");
                    setPgTenantType(opportunity.PgInfo?.TenantType || "");
                    setLicenseCount(opportunity.PgInfo?.NumberofRooms || "");
                    setBasePlanDeviceCount(opportunity.PgInfo?.PlanDevices || "")
                    setBasePlanDataVolume(opportunity.PgInfo?.DataVolume || "")
                    setBasePlanSpeed(opportunity.PgInfo?.Speed || "")
                    setPlanDescription(opportunity.PgInfo?.DesignedforDesc || "")
                    setBasePlanName(opportunity.PgInfo?.BasePlanName || "")
                    setPgAddress(opportunity.Buildingname || "");
                    setPgOwnerName(opportunity.ContactPerson || "");
                    setOwnerContact(opportunity.Mobilephone || "");
                    setOwnerEmail(opportunity.Emailaddress || "");
                    setFloorCount(parseInt(opportunity.PgInfo?.TotalNumberofFloors) || 0);
                    setRoomCount(parseInt(opportunity.PgInfo?.NumberofRooms) || 0);
                    setBedCount(parseInt(opportunity.PgInfo?.NumberofBeds) || 0);
                    setFloorList(
                        Object.keys(opportunity.PgInfo)
                            .filter((key) => key.includes("FloorCoverageRequired"))
                            .map((key) => key.replace("CoverageRequired", ""))
                            .join(", ")
                    );
                    setCommonAreaList(opportunity.PgInfo?.CommonArea || "");
                    setOneTimeCharge(opportunity.OTCExtendedAmountB || "");
                    setSecurityDeposit(opportunity.SDExtendedAmount || "");
                    setPricingBasePlancount(opportunity.PgInfo?.NumberofRooms || 0);
                    setPricingBasePlanrate(opportunity.RCAmount);
                    setPricingBasePlanBillingAmt(opportunity.RCExtendedAmountB);
                    setAddOns(opportunity.PgInfo?.AddOnsss || []);
                    setTotalRecurringPrice(opportunity.PgInfo?.TotalRecurringPrice)
                    setBillingAmountFreqBasis(opportunity.PgInfo?.BillingAmount)
                    setBillingFreqValue(opportunity.PgInfo?.BillingFrequency)
                    setEffectivePrice(opportunity.PgInfo?.EffectivePrice)
                } else {
                    setTimeout(() => {
                        Swal.fire({
                            html: '<div style="font-size: 15px;">Failed to Load Data. Please Retry.</div>',
                            width: '29%',
                            timer: 3000, // Display time in milliseconds
                            showConfirmButton: true
                        }).then(() => {
                            // window.location.reload(); // Reloads the current page
                        });
                    }, 500);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, []);


    return (
        <>
            <div className="container-fluid text-light Header-style header">
                <div className="p-3">
                    <span
                        className="m-2"
                        style={{ cursor: "pointer" }}
                        onClick={redirectOpportunity}
                    >
                        <i className="fa-solid fa-arrow-left-long"></i>
                    </span>
                    <span className=" " >PO Document</span>
                    {getOppData > 0 && (
                        <span className=" flr-createCAf" onClick={downloadPDF} style={{ fontSize: "12px" }}>
                            Download
                            <span style={{ marginLeft: "10px" }}><i className="fa-solid fa-download"></i></span>
                        </span>)}
                </div>
            </div>


            {isLoading ? (
                <div className="loader-wrapper">
                    <div className="loader">
                        <img src={loader} alt="loading...."></img>
                    </div>
                </div>
            ) : (
                <>
                    {getOppData > 0 && (
                        <div className="bg-ligh" style={{ padding: "2% 0%" }}>
                            <div className="max-w-4xl mx-auto mt-5 po-docStyle"

                                id="purchase-order">
                                <div className="section-purchase2 page1">
                                    <div>
                                        <h1 className="text-center text-xxl font-bold mb-2 mt-3">
                                            PURCHASE ORDER (PO)
                                        </h1>
                                        <h5 className="text-center text-xl font-bold mb-2">for</h5>
                                        <h5 className="text-center text-xl font-bold mb-2">Spectra Pro-Fi Broadband for PG</h5>
                                    </div>

                                    {/* PG & Order Details Section */}
                                    <section className="section-purchase page-break mt-4">
                                        <h3 className="text-xl font-bold p-2">
                                            1. PG & Order Details
                                        </h3>
                                        <div className="table-responsive calculate-table">
                                            <Table striped bordered hover className="table-sm">
                                                <thead className="text-center table-dark">
                                                    <tr>
                                                        <th className=" px-4 py-2">Parameter</th>
                                                        <th className=" px-4 py-2"> Details</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <th className=" px-4 py-2" colSpan="">PO Number</th>
                                                        <td className=" px-4 py-2" colSpan="">{poNumber}</td>
                                                    </tr>
                                                    <tr>
                                                        <th className=" px-4 py-2"> PO Date </th>
                                                        <td className=" px-4 py-2">{poDate}</td>
                                                    </tr>
                                                    <tr>
                                                        <th className=" px-4 py-2"> PG Name</th>
                                                        <td className=" px-4 py-2">{pgName}</td>
                                                    </tr>
                                                    <tr>
                                                        <th className=" px-4 py-2"> PG Address</th>
                                                        <td className=" px-4 py-2">{pgAddress}</td>
                                                    </tr>
                                                    <tr>
                                                        <th className=" px-4 py-2">PG Owner Name</th>
                                                        <td className=" px-4 py-2">{pgOwnerName}</td>
                                                    </tr>
                                                    <tr>
                                                        <th className=" px-4 py-2">Contact Number</th>
                                                        <td className=" px-4 py-2">{ownerContact}</td>
                                                    </tr>
                                                    <tr>
                                                        <th className=" px-4 py-2">Email ID</th>
                                                        <td className=" px-4 py-2">{ownerEmail}</td>
                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </div>
                                    </section>

                                    {/* Solution Specifications Section */}
                                    <section className="section-purchase page-break">
                                        <h3 className="text-xl font-bold p-2">
                                            2. Solution Specifications
                                        </h3>

                                        <div className="table-responsive calculate-table">
                                            <Table striped bordered hover className="table-sm" >
                                                <thead className="text-center table-dark">
                                                    <tr>
                                                        <th className=" px-4 py-2">
                                                            Parameter
                                                        </th>
                                                        <th className=" px-4 py-2" >
                                                            Details
                                                        </th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    <tr>
                                                        <th className="px-4 py-2"> PG Specifications: </th>
                                                        <td className="" style={{ padding: "2px" }}>
                                                            <Table bordered className="table-sm mb-0">
                                                                <tbody>
                                                                    <tr>
                                                                        <th className="px-4 py-2"> No. of Floors: </th>
                                                                        <td className="px-4 py-2">
                                                                            <strong> {floorCount} </strong>
                                                                        </td>

                                                                    </tr>
                                                                    <tr>
                                                                        <th className="px-4 py-2"> No. of Rooms: </th>
                                                                        <td className="px-4 py-2">
                                                                            <strong> {roomCount} </strong>
                                                                        </td>

                                                                    </tr>
                                                                    <tr>
                                                                        <th className="px-4 py-2"> No. of Beds: </th>
                                                                        <td className="px-4 py-2">
                                                                            <strong> {bedCount} </strong>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </Table>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className=" px-4 py-2" >
                                                            <strong>Targeted Coverage Area :</strong>
                                                        </td>
                                                        <td className=" px-4 py-2">
                                                            <strong>Resident Rooms :</strong> {floorList} <br />
                                                            <strong>Common Areas :</strong> {commonAreaList === "111260000" ? "Yes" : commonAreaList === "111260001" ? "No" : ""}
                                                            <br />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td
                                                            className=" px-4 py-2"
                                                            style={{ backgroundColor: "rgb(242, 242, 242)" }}
                                                        >
                                                            <strong>Wi-Fi Access Points:</strong>
                                                        </td>
                                                        <td className=" px-4 py-2">
                                                            Up to {projectedAPCount} Access Points for coverage of
                                                            Targeted Coverage Area
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td
                                                            className=" px-4 py-2"
                                                            style={{ backgroundColor: "rgb(242, 242, 242)" }}
                                                        >
                                                            <strong>Internet:</strong>
                                                        </td>
                                                        <td className=" px-4 py-2">
                                                            Dual high-speed broadband with automatic backup
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td
                                                            className=" px-4 py-2"
                                                            style={{ backgroundColor: "rgb(242, 242, 242)" }}
                                                        >
                                                            <strong>User Login Process:</strong>
                                                        </td>
                                                        <td className=" px-4 py-2">
                                                            <ul>
                                                                <li>WPA Password (for all users)</li>
                                                                <li>Self-registration via login page</li>
                                                                <li>OTP-based authentication (sent via SMS)</li>
                                                                <li>
                                                                    Hassle-free auto-connect for registered & saved devices
                                                                </li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td
                                                            className=" px-4 py-2"
                                                            style={{ backgroundColor: "rgb(242, 242, 242)" }}
                                                        >
                                                            <strong>Wi-Fi Authentication for other devices:</strong>
                                                        </td>
                                                        <td className=" px-4 py-2">
                                                            Secure Authentication for each device (Configured by Spectra)
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td
                                                            className=" px-4 py-2"
                                                            style={{ backgroundColor: "rgb(242, 242, 242)" }}
                                                        >
                                                            <strong>Installation Timeline:</strong>
                                                        </td>
                                                        <td className=" px-4 py-2">15 to 30 Days</td>
                                                    </tr>
                                                    <tr>
                                                        <td
                                                            className=" px-4 py-2"
                                                            style={{ backgroundColor: "rgb(242, 242, 242)" }}
                                                        >
                                                            <strong>Wi-Fi Network(s):</strong>
                                                        </td>
                                                        <td className=" px-4 py-2">
                                                            2 Wi-Fi Networks: Users | Devices
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </div>
                                    </section>

                                    {/* Base Plan Details Section */}
                                    <section className="section-purchase page-break">
                                        <h3 className="text-xl font-bold p-2">
                                            3. Base Plan Details
                                        </h3>

                                        <div className="table-responsive calculate-table">
                                            <Table striped bordered hover className="table-sm" >
                                                <thead className="text-center table-dark">
                                                    <tr>
                                                        <th className=" px-4 py-2">Parameter</th>
                                                        <th className=" px-4 py-2"> Details</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <th className=" px-4 py-2" colSpan="">PG Type</th>
                                                        <td className=" px-4 py-2" colSpan="">
                                                            {pgTenantType === "111260000"
                                                                ? "Professional"
                                                                : pgTenantType === "111260001"
                                                                    ? "Student"
                                                                    : pgTenantType === "111260002"
                                                                        ? "Hybrid"
                                                                        : "Unknown"}</td>
                                                    </tr>
                                                    <tr>
                                                        <th className=" px-4 py-2"> Base Plan</th>
                                                        <td className=" px-4 py-2">{basePlanName}</td>
                                                    </tr>
                                                    <tr>
                                                        <th className=" px-4 py-2"> Designed for</th>
                                                        <td className=" px-4 py-2">{planDescription}</td>
                                                    </tr>
                                                    <tr>
                                                        <th className=" px-4 py-2"> Speed (Per Device per User)</th>
                                                        <td className=" px-4 py-2"> {basePlanSpeed}</td>
                                                    </tr>
                                                    <tr>
                                                        <th className=" px-4 py-2">Data Volume (Per User per Month)</th>
                                                        <td className=" px-4 py-2">{basePlanDataVolume}</td>
                                                    </tr>
                                                    <tr>
                                                        <th className=" px-4 py-2">Devices (Per User)</th>
                                                        <td className=" px-4 py-2">{basePlanDeviceCount}</td>
                                                    </tr>
                                                    <tr>
                                                        <th className=" px-4 py-2">License Count</th>
                                                        <td className=" px-4 py-2">{licenseCount}</td>
                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </div>
                                    </section>
                                </div>

                                <div className="section-purchase2 page2">
                                    {/* Pricing & Payment Terms Section */}
                                    <section className="section-purchase page-break">
                                        <h3 className="text-xl font-bold p-2"> 4. Pricing & Payment Terms </h3>

                                        <div className="table-responsive calculate-table">
                                            <div className="mt-2 mb-2">  ❖ One-Time Charges</div>

                                            <Table striped bordered hover className="table-sm" >

                                                <thead>
                                                    {/* <tr className="">❖ One-Time Charges</tr> */}
                                                    <tr className="text-center table-dark">
                                                        <th className=" px-4 py-2 text-center" colSpan="2">
                                                            Installation Charges: Spectra Pro-Fi Broadband for PG
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td className=" px-4 py-2">
                                                            One Time Charges (OTC)
                                                        </td>
                                                        <td className=" px-4 py-2">
                                                            &#8377;  {oneTimeCharge}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className=" px-4 py-2">
                                                            Security Deposit (SD)
                                                        </td>
                                                        <td className=" px-4 py-2">
                                                            &#8377;  {securityDeposit}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </div>
                                    </section>

                                    <section className="section-purchase page-break">
                                        <div className="table-responsive calculate-table">
                                            <div className="mt-2 mb-2">  ❖ Recurring Charges</div>
                                            <Table striped bordered hover className="table-sm" >

                                                <thead>
                                                    {/* <tr className="">❖ Recurring Charges</tr> */}
                                                    <tr className="text-center table-dark">
                                                        <th className=" p-2 text-center" colSpan="4">
                                                            Recurring Charges: Spectra Pro-Fi Broadband for PG
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td className=" p-2" colSpan="2">Billing Frequency</td>
                                                        <td className=" p-2 table-primary" colSpan="2">  Half Yearly Advance</td>

                                                    </tr>
                                                    <tr>
                                                        <td className=" p-2">  Plan Name</td>
                                                        <td className=" p-2">  License Count</td>
                                                        <td className=" p-2">  Plan Rate (Per Month)</td>
                                                        <td className=" p-2">  Total Price (Per Month)</td>
                                                    </tr>
                                                    <tr>
                                                        <th className=" p-2" colSpan="4"> Base Plan</th>
                                                    </tr>
                                                    <tr>
                                                        <th className=" p-2 table-primary"  >Base Plan Name{" "}</th>
                                                        <td className=" p-2">{pricingBasePlancount}</td>
                                                        <td className=" p-2">&#8377;  {pricingBasePlanrate}</td>
                                                        <td className=" p-2">  &#8377;  {pricingBasePlanBillingAmt}</td>
                                                    </tr>
                                                    <tr>
                                                        <th className=" p-2" colSpan="4"> Add-on Plans </th>
                                                    </tr>
                                                    {addOns.length > 0 ? (
                                                        addOns.map((addon, index) => (
                                                            <tr key={index}>
                                                                <td className="  p-2 table-primary">
                                                                    <strong>{addon.ProductName || "N/A"}</strong>
                                                                </td>
                                                                <td className="  p-2">
                                                                    {addon.LicenseCount || 0}
                                                                </td>
                                                                <td className="  p-2">
                                                                    &#8377;  {addon.PlaneRate || 0}
                                                                </td>
                                                                <td className="  p-2">
                                                                    &#8377;  {addon.TotalPrice || 0}
                                                                </td>
                                                                {/* <td className="  p-2 table-primary">
                                                &#8377;  {addon.TotalPrice || 0}
                                            </td> */}
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td
                                                                colSpan="4"
                                                                className=" py-2 text-center"
                                                            >
                                                                No Add-On Plans Available
                                                            </td>
                                                        </tr>
                                                    )}

                                                    <tr className=" bg-yellow-200 font-bold">
                                                        <th className="p-2 " colSpan="3"> Total Recurring Price (per Month) </th>
                                                        <td className="p-2 " >&#8377;  {totalRecurringPrice} </td>
                                                    </tr>


                                                    <tr className=" font-bold" style={{ backgroundColor: "#6f9c68" }}>
                                                        <th className="p-2 " colSpan="3" > Billing Amount ({billingFreqValue} basis) per Month </th>
                                                        <td className="p-2 ">&#8377;  {billingAmountFreqBasis}</td>
                                                    </tr>



                                                    <tr className=" bg-yellow-200 font-bold">
                                                        <th className="p-2 " colSpan="3"> Effective Price (per Room per Month)</th>
                                                        <td className="p-2 "> &#8377;  {effectivePrice}  </td>
                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </div>



                                        <ul className="list-disc pl-5">
                                            <li>Taxes extra as applicable on all above charges</li>
                                            <li>
                                                First payment includes OTC + SD + first billing period charges.
                                            </li>
                                            <li>
                                                Billing: First payment at installation (One-Time Charges, Security
                                                Deposit and Recurring Charges)
                                            </li>
                                            <li>
                                                Billing Frequency:{" "}
                                                <strong>{billingFreqValue}</strong> (Advance Only)
                                            </li>
                                            <li>
                                                Billing Commencement: Upon successful installation and acceptance
                                                by the PG owner.
                                            </li>
                                        </ul>
                                    </section>

                                    {/* Contact & Legal Terms Section */}
                                    <section className="section-purchase page-break">
                                        <h3
                                            className="text-xl font-bold p-2"
                                        >
                                            5. Contract & Legal Terms
                                        </h3>
                                        <ul className="list-disc pl-5 mb-4">
                                            <li>
                                                <strong>Lock-In Term:</strong> 5 Years from the billing
                                                commencement date
                                            </li>
                                            <li>
                                                <strong>Contract Term:</strong> 5 Years from the billing
                                                commencement date
                                            </li>
                                            <li>
                                                <strong>Payment & Suspension Policy:</strong>
                                                <ul className="list-disc pl-5">
                                                    <li>Invoices must be paid within 5 days of issuance</li>
                                                    <li>
                                                        If payment is not made within 5 days, Spectra reserves the
                                                        right to suspend services without further notice until
                                                        clearance of dues
                                                    </li>
                                                    <li>
                                                        A late payment fee of 3% per month will apply after the due
                                                        date
                                                    </li>
                                                </ul>
                                            </li>
                                        </ul>

                                        <div className="mb-4">
                                            <div className="font-bold mb-2">
                                                <strong>Equipment Ownership</strong>
                                            </div>
                                            <ul className="list-disc pl-5">
                                                <li>
                                                    All equipment (Wi-Fi APs, switches, cables) shall remain the
                                                    property of Spectra
                                                </li>
                                            </ul>
                                        </div>

                                        <div className="mb-4">
                                            <div className="font-bold mb-2">
                                                <strong>Refund of Security Deposit</strong>
                                            </div>
                                            <ul className="list-disc pl-5">
                                                <li>
                                                    The Security Deposit shall be refunded within 60 days of
                                                    contract termination, subject to:
                                                    <ul className="list-disc pl-5">
                                                        <li>No pending dues or breach of contract</li>
                                                        <li>
                                                            Safe return of all Spectra equipment in working condition
                                                        </li>
                                                        <li>No damage or loss of hardware</li>
                                                        <li>
                                                            Completion of all exit formalities and access for
                                                            deinstallation
                                                        </li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </div>

                                        <div className="mb-4">
                                            <div className="font-bold mb-2">
                                                <strong>Cancellation Policy / Exit Policy</strong>
                                            </div>
                                            <ul className="list-disc pl-5">
                                                <li>
                                                    In case of early termination, PG owner must pay the remaining
                                                    contract value
                                                </li>
                                            </ul>
                                        </div>

                                        <div className="mb-4">
                                            <div className="font-bold mb-2">
                                                <strong>Responsibility of PG</strong>
                                            </div>
                                            <ul className="list-disc pl-5">
                                                <li>Provide access for installation and maintenance</li>
                                                <li>
                                                    Ensure power supply, power backup and security for installed
                                                    equipment
                                                </li>
                                                <li>
                                                    Ensure safe environment for all equipment deployed by Spectra
                                                </li>
                                            </ul>
                                        </div>


                                    </section>
                                </div>

                                <div className="section-purchase2 page2">
                                    <div className="mt-4">
                                        <div className="font-bold mb-2">
                                            <strong>PG Owner Declaration :</strong>
                                        </div>

                                        <div className="table-responsive calculate-table">
                                            <Table striped bordered hover className="table-sm" >
                                                <tbody>
                                                    <tr>
                                                        <td className="px-4 py-2 " colSpan="4">
                                                            I, <strong>{pgOwnerName}</strong>, hereby authorize Spectra
                                                            to proceed with the installation and service activation as
                                                            per this order.
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="px-4 py-2 " colSpan="2">
                                                            <strong>Authorized Signatory (PG)</strong>
                                                        </td>
                                                        <td className="px-4 py-2 " colSpan="2"></td>
                                                    </tr>
                                                    <tr>
                                                        <td className="px-4 py-2 " colSpan="2">
                                                            <strong>Name</strong>
                                                        </td>
                                                        <td className="px-4 py-2 " colSpan="2">
                                                            {/* &lt;&lt;Authorized Signatory Name&gt;&gt; */}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="px-4 py-2 " colSpan="2">
                                                            <strong>Date of Order Confirmation</strong>
                                                        </td>
                                                        <td className="px-4 py-2 " colSpan="2">
                                                            {/* &lt;&lt;Order Date&gt;&gt; */}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="px-4 py-2 " colSpan="2">
                                                            <strong>Signature & Stamp</strong>
                                                        </td>
                                                        <td className="px-4 py-2 " colSpan="2"></td>
                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </>
            )}

        </>
    );
};

export default PurchaseOrder;